<script lang="ts">
import { iIcon } from '@inscribe/signal';
import { ChatContextType } from '@/types/chat';

export default {
  name: 'ChatContext',
  components: { iIcon },
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      ChatContextType,
    };
  },
  computed: {
    label() {
      switch (this.context.type) {
        case ChatContextType.Customer:
          return this.context.customerName;
        case ChatContextType.Document:
          return this.context.documentName;
        default:
          return '';
      }
    },
  },
  methods: {
    onContextClick() {
      switch (this.context.type) {
        case ChatContextType.Customer:
          this.$router.push(`/customer/${this.context.customerUuid}/overview`);
          break;
        case ChatContextType.Document:
          this.$router.push(
            `/customer/${this.context.customerUuid}/document/${this.context.documentId}`,
          );
          break;
      }
    },
  },
};
</script>

<template>
  <div
    class="chat-context d-flex align-items-center i-radius-lg i-px-4 i-py-3 i-gap-3"
    @click="onContextClick"
  >
    <i-icon
      :symbol="
        context.type === ChatContextType.Customer
          ? 'small-user-single'
          : 'small-file'
      "
      :size="12"
      :colour="'var(--icon-neutral-subtle)'"
    />
    <div class="name i-text-subheading-3">{{ label }}</div>
  </div>
</template>

<style lang="scss" scoped>
.chat-context {
  border: 1px solid var(--border-neutral-subtle);
  background-color: var(--base);
  color: var(--text-neutral-bold);
  cursor: pointer;

  .name {
    max-width: 160px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
</style>
